export const environment = {
    production: true,
    // serverURL: 'https://pinnacleapi.azurewebsites.net',
    serverURL: 'https://server19pdf.apidas.com',  
    siteReviewURL: 'https://server19.apidas.com',    
    //siteReviewURL: 'https://beta-api.apidas.com',
    
    authRedirectUri: 'https://dev.pinnaclepowerservices/sessions/loading',
    authSignInUrl: 'https://dev.pinnaclepowerservices/sessions/signin',
     supportUrl: 'https://support.pinnaclepowerservices.com',
    trashFolder: '18OJv1-wWz8Dw6ll_0c1dlthdEnEY3JFO',
    adobePDFkey:'058ae776ee354cec8f289d990a9d1dd9',
    authenticationExpirationTimeoutMinutes: 36000,  //(10 hours - per tyler request)
    googleAPIKey: "AIzaSyD7gtowPV_w4QT11oiVAcet29mWzSrSsgU",
    env: 'development' as const,
    closeoutPollIntervalSeconds: 5,
    closeoutPollTimeoutSeconds: 120,
  };
  

  /*
  serverURL: 'https://pinnacleapi.azurewebsites.net',
    siteReviewURL: 'https://sitereviewapi.azurewebsites.net',    
    
    */